
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

export default {
name: 'Notice',
props: ['items'],
components: { Swiper, SwiperItem },
data () {
return {
}
},
methods: {
clickNoticeItem (noticeIndex) {
this.$emit('clickNoticeItem', noticeIndex)
}
}
}



// WEBPACK FOOTER //
// ./src/views/Home/components/Notice/Notice.vue